import angular from 'angular';

import 'angular-ui-router';
import 'angular-aria';
import 'angular-animate';
import 'angular-material';
import 'ng-file-upload';
import 'angular-material/angular-material.css';

import 'angular-messages';
import 'angular-material-icons';
import './styles/bootstrap/css/bootstrap.min.css';

//require('../olr-mainfe-indv-class/addExamPopup.html');

import '../images/Material-design.jpg';
import '../images/absent.png';
import '../images/add_announcement.png';
import '../images/attendance.jpg';
import '../images/classroom.jpg';
import '../images/homework.jpg';
import '../images/present.png';
import '../images/todo.jpg';
import '../images/notifications.jpg';
import '../images/unauth_img.jpg';
import '../images/view-dashboard.svg';
import '../images/ic_menu_white_24px.svg';
import '../images/ic_person_add_white_24px.svg';
import '../images/ic_grade_white_24px.svg';
import '../images/ic_assignment_white_24px.svg';
import '../images/ic_search_black_24px.svg';

import InitialController from './InitialController';
import Common from '../olr-common';
import Oauth from '../olr-mainfe-oauth2';
import API from '../olr-mainfe-api';
import Directives from '../olr-directives';
import ServiceStubs from '../olr-servicestubs';
import Landing from '../olr-mainfe-landing';
import Account from '../olr-mainfe-account';
import Attendance from '../olr-mainfe-attendance';
import Dashboard from '../olr-mainfe-dashboard';
import Announcement from '../olr-mainfe-announcement';
import Class from '../olr-mainfe-class';
import indvClass from '../olr-mainfe-indv-class';
import MainController from './MainController';
import Unauth from '../olr-mainfe-unauth';
import Homework from '../olr-mainfe-homework';
import Reports from '../olr-mainfe-reports';
import Admin from '../olr-mainfe-admin';

import './header.htm';
import './sidenav.htm';
import '../olr-mainfe-dashboard/addSubPopup.html';
import '../olr-mainfe-class/addClassPopupExt.html';
import '../olr-mainfe-class/addClassPopup.html';
import '../olr-mainfe-indv-class/addExamPopup.htm';
import '../olr-mainfe-indv-class/addMarksPopup.htm';
import '../olr-mainfe-indv-class/addStudentPopup.htm';
import containerTemplate from './main-template.html';
import content from './content.html';
import './styles/index.scss';
import moment from 'moment';

// Set application name
//Settings.application = 'mainfe';

let mainfe = angular.module('olr-mainfe', [
  'ui.router',
  'ngMaterial',
  'ngAnimate',
  'ngAria',
  'ngMessages',
  'ngFileUpload',
  Common,
  Oauth,
  API,
  Directives,
  Landing,
  Account,
  Attendance,
  Dashboard,
  Announcement,
  Class,
  indvClass,
  Unauth,
  Homework,
  Reports,
  Admin
]);

export default mainfe;

//olr.requires.push(mainfe.name);

mainfe.config(function(localStorageServiceProvider, $urlRouterProvider, $stateProvider, $locationProvider, $mdThemingProvider, $mdDateLocaleProvider) {
  localStorageServiceProvider
    .setPrefix("olr-mainfe") // will prefix "olr-mainfe" to all keys
    .setStorageType("sessionStorage"); // clear local storage when app is closed

  $locationProvider.html5Mode(true);

  $mdDateLocaleProvider.formatDate = function(date) {
    return moment(date).format('DD/MM/YYYY');
  };

  $mdThemingProvider.theme('default')
    .primaryPalette('deep-purple')
    .accentPalette('pink')
    .warnPalette('red')
    .backgroundPalette('grey');

  //$httpProvider.interceptors.push("HttpInterceptorService");

    $stateProvider.state('olr', {
    abstract: true,
    template: containerTemplate,
    // resolve: {
    //   checkChannel: function(LandingService, $location, $injector) {
    //     return LandingService.checkChannel($location, $injector);
    //   }
    // },
    controller: InitialController 
  });

  $stateProvider.state('olr.mainfe', {
    abstract: true,
    url: "/main",
    views: {
      content: {
        template: content,
      }
    },
    resolve: {
       // authorizeGoogleUser: authorizeGoogleUser
    },
    // controller: AbstractController
  });

  // $stateProvider.state('olr.mainfe', {
  //   abstract: true,
  //   url: "/main",
  //   template: template
  // });

  $urlRouterProvider.otherwise(function($injector) {
    var $state = $injector.get("$state");
    var localStorageService = $injector.get("localStorageService");
    var $location = $injector.get("$location");
    var currentUrl = $location.absUrl();

    if(currentUrl.indexOf('code') > -1){
      var code = currentUrl.substring(currentUrl.lastIndexOf("code=")+5,currentUrl.lastIndexOf("&scope"));
      localStorageService.set('code', code);
    }
    console.log('gotolanding');
    $state.go("olr.mainfe.landing");
    
  });

});

mainfe.controller('MainController', MainController);
mainfe.controller('InitialController', InitialController);

// This must load last
ServiceStubs(mainfe);




/** WEBPACK FOOTER **
 ** ./src/olr-mainfe/index.js
 **/